import { React, Render } from 'uweb'
import { Connection } from 'unet/web'
import { KeyValue } from 'utils/web'
import { EventEmitter } from "events"

import { AddMeta, Persist } from './hooks/helper'
import Main from './main'

const proxy = undefined
const timeout = 15000 * 4

const cfg: iArgs = {

    isDarkMode: true,
    setIsDarMode: null,
    kv: new Persist(),
    event: new EventEmitter(),
    messageApi: null,
    notifApi: null,

    core_proxy: new Connection({ proxy, name: 'core_proxy', token: KeyValue('token'), timeout }),
    core_data: new Connection({ proxy, name: 'core_data', token: KeyValue('token'), timeout }),
    core_collect: new Connection({ proxy, name: 'core_collect', token: KeyValue('token'), timeout }),

}

const defs = [

    { key: 'Last Config', value: `${Date.now()}` },
    { key: '3D', value: 'no' },
    { key: 'Elevation', value: '1200' },
    { key: 'mode', value: 'true' },
    { key: 'Base tile', value: 'true' },
    { key: 'Geofences', value: 'true' },
    { key: 'Last View', value: 'false' },

].map(({ key, value }) => {

    const got = KeyValue(key)

    if (got === '') KeyValue(key, value)
    else if (got === 'NaN') KeyValue(key, value)
    else if (got === undefined) KeyValue(key, value)
    else if (got === null) KeyValue(key, value)

})

Render((args: any) => {

    React.useMemo(() => {

        AddMeta()

        cfg.setIsDarMode = args.setIsDarkMode

        cfg.kv.on('token', (next) => cfg.kv.get('token') !== next && location.reload())

        window.addEventListener("focus", () => {

            cfg.core_proxy.connect()
            cfg.core_data.connect()
            cfg.core_collect.connect()

        })

    }, [])

    return <Main {...cfg} isDarkMode={args.isDarkMode} />

}, null, { maxWidth: '100%' })